import React from 'react';
import BreadCrumb from 'Common/BreadCrumb';
import CreditDestinationCRUD from './CreditDestination';

const ExpenseCategory = () => {
    return (
        <React.Fragment>
            <div className="container-fluid group-data-[content=boxed]:max-w-boxed mx-auto">
                <BreadCrumb title='Listado de Destinos de Prestamo' pageTitle='Destinos de Prestamo' />
                <CreditDestinationCRUD />
            </div>
        </React.Fragment>
    )
}

export default ExpenseCategory;